import { UserIcon } from "@heroicons/react/24/solid";
import "./../css/index.css";
import { EllipsisHorizontalIcon } from "@heroicons/react/24/outline";
import EllipsisCard from "../EllipsisCard";

const HierarchyOrgChartNode = (props) => {
  const parent_depth = props.node.parent?.depth;
  const { depth, row } = props.node;

  const colors_depth = [
    "#203A75",
    "#0C77BD",
    "#069EDB",
    "#58C9FE",
    "#9CE0FF",
    "#D2F1FF",
  ];

  const primary =
    (!row ? colors_depth[depth] : colors_depth[parent_depth + 1]) ??
    colors_depth[colors_depth.length - 1];

  //#region Styles for download
  const nodeCardBU = {
    width: "229px",
    height: "115px",
    borderRadius: "8px",
    position: "relative",
    overflow: "visible",
    backgroundColor: "#ffffff",
    border: "1px solid #203a75",
    boxSizing: "border-box",
  };

  const nodeCardMarket = {
    width: "229px",
    height: "115px",
    borderRadius: "8px",
    position: "relative",
    overflow: "visible",
    backgroundColor: "#ffffff",
    border: "1px solid #0c77bd",
    boxSizing: "border-box",
  };

  const nodeCardState = {
    width: "229px",
    height: "115px",
    borderRadius: "8px",
    position: "relative",
    overflow: "visible",
    backgroundColor: "#ffffff",
    border: "1px solid #069edb",
    boxSizing: "border-box",
  };

  const nodeCardDistrict = {
    width: "229px",
    height: "115px",
    borderRadius: "8px",
    position: "relative",
    overflow: "visible",
    backgroundColor: "#ffffff",
    border: "1px solid #9ce0ff",
    boxSizing: "border-box",
  };

  const nodeCardTeam = {
    width: "229px",
    height: "115px",
    borderRadius: "8px",
    position: "relative",
    overflow: "visible",
    backgroundColor: "#ffffff",
    border: "1px solid #9ce0ff",
    boxSizing: "border-box",
  };

  const nodeCardFrontlines = {
    width: "229px",
    height: "95px",
    borderRadius: "8px",
    position: "relative",
    overflow: "visible",
    backgroundColor: "#ffffff",
    border: "1px solid #9ce0ff",
    boxSizing: "border-box",
  };

  const foldedCorner = {
    position: "absolute",
    top: "-2px",
    right: "12px",
    width: "0",
    height: "26px",
    borderTop: "19px solid transparent",
    marginTop: "-14px",
    transform: "rotate(140deg)",
    opacity: "80%",
    borderLeft: `21px solid ${primary}`,
    boxSizing: "border-box",
  };

  const ellipsis = {
    right: "9px",
    top: "2px",
    position: "absolute",
    cursor: "pointer",
  };

  const ellipsisIcon = {
    height: "1.5rem",
    width: "1.5rem",
    color: "#203A75",
  };

  const nameEllipsis = {
    backgroundColor: primary,
    width: "232px",
    height: "75px",
    color: "white",
    padding: "12px",
    borderTopLeftRadius: "20px",
    borderBottomLeftRadius: "20px",
    display: "flex",
    transform: "translateX(-12%)",
    clipPath: "polygon(0 0, 100% 0, 80% 100%, 0% 100%)",
    position: "relative",
    marginTop: "-20px",
    boxSizing: "border-box",
  };

  const userIconStyle = {
    borderRadius: "9999px",
    backgroundColor:
      props.node.data.hierarchyTypeName === "Frontline" ||
      props.node.data.hierarchyTypeName === "Team"
        ? "#203A75"
        : "white",
    width: "fit-content",
    height: "fit-content",
    padding: "0.75rem",
  };

  const nodeCardName = {
    color: "#ffffff",
  };

  const districtEmployeeName = {
    textDecoration: "underline",
    marginLeft: "0.5rem",
    marginBottom: "0.5rem",
    marginTop: "0px",
    fontSize: "12px",
    color: "#203A75",
  };

  const textStyle = {
    fontSize: "0.75rem",
    color: "#203A75",
  };

  const employeeNumber = {
    marginLeft: "1rem",
    marginTop: "0.5rem",
    marginBottom: "0px",
    paddingLeft: "1rem",
    fontSize: "0.75rem",
    fontWeight: "normal",
    color: "#203A75",
  };

  const hierarchyName = {
    marginLeft: "1rem",
    marginTop: "0.25rem",
    marginBottom: "0px",
    paddingLeft: "1rem",
    fontSize: "0.75rem",
    fontWeight: "normal",
    color: "#203A75",
    textDecoration: "underline",
  };

  const employeeRoleTitle = {
    marginTop: "0px",
    marginBottom: "0px",
    marginRight: "0px",
    fontSize: "12px",
    marginLeft: "0.5rem",
  };

  const employeeName = {
    textDecoration: "underline",
    marginLeft: "0.5rem",
    marginBottom: "0.5rem",
    marginTop: "0px",
    fontSize: "12px",
  };
  //#endregion

  //#region Node card styles
  const hierarchyTypeStyles = {
    "Business Unit": nodeCardBU,
    Market: nodeCardMarket,
    State: nodeCardState,
    District: nodeCardDistrict,
    Team: nodeCardTeam,
    Frontline: nodeCardFrontlines,
  };

  const styles =
    hierarchyTypeStyles[props.node.data.hierarchyTypeName] || nodeCardTeam;
  //#endregion

  //#region Node card class
  const hierarchyTypeClass = {
    "Business Unit": `node-card_wrapper BU`,
    Market: `node-card_wrapper Market`,
    State: `node-card_wrapper State`,
    District: `node-card_wrapper District`,
    Team: `node-card_wrapper Team`,
    Frontline: `node-card_wrapper Team`,
  };

  const classNames = hierarchyTypeClass[props.node.data.hierarchyTypeName];
  //#endregion

  return (
    <>
      <div className={classNames} style={styles}>
        {props.node.data.hierarchyTypeName === "District" ? (
          <>
            <div className="folded-corner" style={foldedCorner}></div>
            {props.hierarchyId === props.node.data.hierarchyId
              ? props.cardShow && (
                  <EllipsisCard
                    userPermission={props.userPermissions}
                    editPermission={props.editPermission}
                    deletePermission={props.deletePermission}
                    splcHierarchyData={props.splcHierarchyData}
                  />
                )
              : ""}
            <div className="node-card_ellipsis" style={ellipsis}>
              <EllipsisHorizontalIcon
                className={`h-6 w-6 text-primary`}
                style={ellipsisIcon}
              />
            </div>
            <div className="node-card_name-ellipsis" style={nameEllipsis}>
              <div
                className="rounded-full bg-white w-fit p-3 h-fit"
                style={userIconStyle}
              >
                <UserIcon
                  className={"w-4"}
                  style={{ fill: primary, width: "1rem" }}
                />
              </div>
              <div
                className="node-card_name font-semibold"
                style={nodeCardName}
              >
                <h3 className="employeeName" style={districtEmployeeName}>
                  {props.node.data.employeeName}
                </h3>

                <div
                  className="text-xs text-primary"
                  style={{ fontSize: "0.75rem" }}
                >
                  <h3 className="ml-2" style={employeeRoleTitle}>
                    {props.node.data.employeeRole}
                  </h3>
                </div>
                <div
                  className="text-xs text-primary"
                  style={{ fontSize: "0.75rem" }}
                >
                  <h3 className="ml-2" style={employeeRoleTitle}>
                    {props.node.data.hierarchyTypeName}
                  </h3>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="folded-corner" style={foldedCorner}></div>
            {props.hierarchyId === props.node.data.hierarchyId
              ? props.cardShow && (
                  <EllipsisCard
                    userPermission={props.userPermissions}
                    editPermission={props.editPermission}
                    deletePermission={props.deletePermission}
                    splcHierarchyData={props.splcHierarchyData}
                  />
                )
              : ""}
            <div className="node-card_ellipsis" style={ellipsis}>
              {props.node.data.parentId !== "" &&
                props.node.data.hierarchyTypeName !== "Frontline" && (
                  <EllipsisHorizontalIcon
                    className={`h-6 w-6 text-primary`}
                    style={ellipsisIcon}
                  />
                )}
            </div>
            <div
              className={
                props.node.data.hierarchyTypeName !== "Business Unit"
                  ? "node-card_name-ellipsis"
                  : "node-card_name-ellipsis"
              }
              style={nameEllipsis}
            >
              <div
                className="rounded-full bg-white w-fit p-3 h-fit"
                style={userIconStyle}
              >
                <UserIcon
                  className={"w-4"}
                  style={{
                    fill:
                      props.node.data.hierarchyTypeName === "Frontline" ||
                      props.node.data.hierarchyTypeName === "Team"
                        ? "white"
                        : primary,
                    width: "1rem",
                  }}
                />
              </div>
              <div
                className={
                  props.node.data.hierarchyTypeName === "Frontline" ||
                  props.node.data.hierarchyTypeName === "Team"
                    ? "text-primary"
                    : "node-card_name"
                }
                style={
                  props.node.data.hierarchyTypeName === "Frontline" ||
                  props.node.data.hierarchyTypeName === "Team"
                    ? { color: "#203A75" }
                    : nodeCardName
                }
              >
                <h3
                  className="employeeName truncate w-40 font-bold"
                  style={employeeName}
                >
                  {props.node.data.employeeName}
                </h3>

                <div className="text-xs" style={{ fontSize: "0.75rem" }}>
                  <h3 className="ml-2" style={employeeRoleTitle}>
                    {props.node.data.hierarchyTypeName === "Frontline" ||
                    props.node.data.parentId === ""
                      ? props.node.data.employeeTitle
                      : props.node.data.employeeRole}
                  </h3>
                </div>
                <div className="text-xs" style={{ fontSize: "0.75rem" }}>
                  <h3 className="ml-2" style={employeeRoleTitle}>
                    {props.node.data.parentId !== ""
                      ? props.node.data.hierarchyTypeName !== "Frontline"
                        ? props.node.data.hierarchyTypeName
                        : props.node.data.hierarchyName
                      : ""}
                  </h3>
                </div>
              </div>
            </div>
          </>
        )}
        <div className="node-card_type">
          <h3
            className="ml-4 mt-2 pl-4 text-xs text-primary"
            style={employeeNumber}
          >
            {props.node.data.employeeNumber}
          </h3>
        </div>
        <div>
          <h3 className="hierarchyName" style={hierarchyName}>
            {props.node.data.hierarchyTypeName !== "Frontline" &&
            props.node.data.parentId !== ""
              ? props.node.data.hierarchyName
              : ""}
          </h3>
        </div>
      </div>
    </>
  );
};
HierarchyOrgChartNode.propTypes = {};

export default HierarchyOrgChartNode;
